import React from 'react';

import { GtpWalletInfoResult } from '@eika-infrastruktur/mobilbank-lib';
import CenteredLoader from '@eika-kortbetjening/state-handling-modal/lib/loader/Loader';
import { ErrorMessage } from '@eika/attention-message';

import piwik from '@/piwik/piwik';

import { useGetOPCGooglePayProvisionMutation } from '@domain/digital-wallet';
import { Card } from '@generated-types';
import useText from '@hooks/use-text';

import { AddToGooglePayImage } from './image/AddToGooglePayImage';

import './AddToGooglePayButton.scss';

interface AddToGooglePayPropsButtonProps {
    onClick: () => void;
}
interface AddToGooglePayWithSigningProps {
    startGooglePayActivationWithSigning: () => void;
}

interface AddToGooglePaySteppedUpProps {
    card: Card;
    googleWalletInfo: GtpWalletInfoResult;
}

const AddToGooglePayButton = ({ onClick }: AddToGooglePayPropsButtonProps) => (
    <button
        type="button"
        className="add-to-google-pay-button"
        onClick={() => onClick()}
        aria-label="add-to-google-pay-button"
        data-track-id={piwik.googlePay.addToGooglePay.dataTrackId}
        data-track-linkname={piwik.googlePay.addToGooglePay.dataTrackLinkname}
    >
        <AddToGooglePayImage />
    </button>
);

export const AddToGooglePayWithSigning = ({ startGooglePayActivationWithSigning }: AddToGooglePayWithSigningProps) => (
    <AddToGooglePayButton onClick={startGooglePayActivationWithSigning} />
);

export const AddToGooglePaySteppedUp = ({ card, googleWalletInfo }: AddToGooglePaySteppedUpProps) => {
    const provisionQuery = useGetOPCGooglePayProvisionMutation({ card, walletInfoResult: googleWalletInfo });

    const { googleWalletOPCError } = useText();

    if (provisionQuery.isPending) {
        return <CenteredLoader />;
    }

    if (provisionQuery.isError) {
        return <ErrorMessage text={googleWalletOPCError} />;
    }

    return <AddToGooglePayButton onClick={provisionQuery.mutate} />;
};
